import React from "react";
import {
  DemoResponsiveGrid,
  DemoWorkbenchCard,
  DemoWorkbenchCopy,
  DemoWorkbenchFact,
  DemoWorkbenchFactGrid,
  DemoWorkbenchStack,
  DemoWorkbenchTable,
  type DemoWorkbenchFactTone,
} from "@csk/demo-ui";
import scoringConformanceData from "../data/scoring-conformance.json";

const { scores: SCORES, golden: GOLDEN } = scoringConformanceData;
const SCORE_TONE: Readonly<Record<string, DemoWorkbenchFactTone>> = {
  "text-amber-400": "warning",
  "text-cyan-400": "accent",
  "text-green-400": "success",
  "text-purple-400": "accent",
  "text-red-400": "danger",
};

const ScoringConformancePanel = (): React.JSX.Element => {
  return (
    <DemoWorkbenchStack>
      <DemoWorkbenchCard title="Scoring Pipeline + Conformance">
        <DemoWorkbenchCopy>
          Five derived scores from the 4-axis footprint. All closed-form, all
          proved monotone. 2,148 golden test points.
        </DemoWorkbenchCopy>
      </DemoWorkbenchCard>

      <DemoResponsiveGrid minColumnWidth={130} gap={8}>
        {SCORES.map((s, i) => (
          <DemoWorkbenchFact
            key={i}
            label={s.name}
            value={s.formula}
            detail={s.example}
            tone={SCORE_TONE[s.color] ?? "default"}
            mono
          />
        ))}
      </DemoResponsiveGrid>

      <DemoWorkbenchCard compact>
        <DemoWorkbenchCopy tone="muted" className="mb-2">
          Golden Data Sample (from 2,148 test points)
        </DemoWorkbenchCopy>
        <DemoWorkbenchTable
          compact
          headers={["Footprint v", "E", "κ", "Regime", "Conformance"]}
          rows={GOLDEN.map((row) => [
            row.input,
            row.E,
            row.kappa,
            row.regime,
            <span key={row.input} className="text-green-400">
              {row.status}
            </span>,
          ])}
        />
      </DemoWorkbenchCard>

      <DemoWorkbenchCard compact>
        <DemoWorkbenchCopy tone="muted" className="mb-2">
          Pipeline: 11 Lenses → 4 Axes → 5 Scores → Regime
        </DemoWorkbenchCopy>
        <DemoWorkbenchFactGrid minColumnWidth={150}>
          <DemoWorkbenchFact
            label="Step 1"
            value="11 security lenses"
            tone="warning"
          />
          <DemoWorkbenchFact
            label="Step 2"
            value="4 axis scores (G1-G4)"
            tone="accent"
          />
          <DemoWorkbenchFact
            label="Step 3"
            value="5 derived scores (E,κ,ρ,d_R,B)"
            tone="accent"
          />
          <DemoWorkbenchFact
            label="Step 4"
            value="Regime (R1/R2/R3)"
            tone="success"
          />
        </DemoWorkbenchFactGrid>
      </DemoWorkbenchCard>
    </DemoWorkbenchStack>
  );
};

export default ScoringConformancePanel;
